export enum PermissionsDispersion {
  transferenciaCupo = 32000,
}
